import { Button } from '@/components/ui/button';
import { ShoppingCart, Heart, Zap } from 'lucide-react';
import { Separator } from '@/components/ui/separator';
import { TrustBadges } from './TrustBadges';
import { StockUrgency } from './StockUrgency';
import { WhatsAppHelp } from './WhatsAppHelp';

interface ProductActionsProps {
  onAddToCart: () => void;
  onBuyNow?: (type: 'razorpay' | 'shiprocket') => void;
  stock: number;
  compact?: boolean;
  showBuyNow?: boolean;
  productName?: string;
}

export const ProductActions = ({ 
  onAddToCart, 
  onBuyNow,
  stock, 
  compact = false,
  showBuyNow = true,
  productName
}: ProductActionsProps) => {
  if (compact) {
    return (
      <Button 
        onClick={onAddToCart}
        disabled={stock === 0}
        className="whitespace-nowrap px-4 py-2 h-auto text-sm"
        size="sm"
      >
        {stock === 0 ? 'Out of Stock' : 'Add to Cart'}
      </Button>
    );
  }
  
  return (
    <div className="space-y-3">
      <StockUrgency stock={stock} />
      
      {/* Add to Cart row - hidden on mobile, shown on tablet/desktop */}
      <div className="hidden md:flex gap-3">
        <Button 
          onClick={onAddToCart} 
          disabled={stock <= 0}
          className="flex-1"
        >
          <ShoppingCart className="mr-2 h-4 w-4" />
          Add to Cart
        </Button>
        <Button variant="outline" size="icon">
          <Heart className="h-4 w-4" />
        </Button>
      </div>
      
      {showBuyNow && onBuyNow && (
        <>
          <Separator />
          <p className="text-sm text-muted-foreground text-center">Express Checkout</p>
          <Button 
            onClick={() => onBuyNow('razorpay')}
            disabled={stock <= 0}
            className="w-full"
            size="lg"
          >
            <Zap className="mr-1.5 h-4 w-4 shrink-0" />
            Buy Now
          </Button>
        </>
      )}
      
      <TrustBadges />
      
      <div className="flex justify-center pt-1">
        <WhatsAppHelp productName={productName} />
      </div>
    </div>
  );
};
